const basePath = '/av-billing-infos';

export class AvBillingInfoPath {
  static index() {
    return basePath;
  }
}
